// extracted by mini-css-extract-plugin
export default {"tooltip":"pV-z","arrow":"qV-z"};